<template>
  <div>
    <v-layout row wrap justify-space-between align-center>
      <v-flex>
        <v-subheader class="pl-0">
          Filtros
        </v-subheader>
      </v-flex>
      <v-flex md10 text-xs-right>
        <v-btn v-if="showBtn" small depressed round class="k-orange-linear mr-0" @click.stop="filtersDialog = true">
          <v-icon small class="mr-1">
            fas fa-plus
          </v-icon>
          Agregar filtros
        </v-btn>
      </v-flex>
    </v-layout>
    <template v-if="filters.items.length">
      <v-layout row wrap mb-2 v-if="filters.items.length > 1">
        <v-flex v-if="showBtn" offset-xs4 xs3>
          <v-radio-group row v-model="filters.operator" :hide-details="true">
            <v-radio label="Y" value="and" class="ml-4" />
            <v-radio label="O" value="or" />
          </v-radio-group>
        </v-flex>
      </v-layout>
      <scrollbar style="height: 150px;">
        <div class="filter-groups-wrap">
          <template v-for="(group, i) in filters.items">
            <div :key="`group-${i}`" class="filter-group-card">
              <div class="filter-group-header">
                <div class="filter-group-actions" v-if="showBtn">
                  <v-btn class="k-orange-linear" @click="editGroup(i)" small icon round>
                    <v-icon small>fas fa-pencil-alt</v-icon>
                  </v-btn>
                  <v-btn class="k-orange-linear" @click="deleteGroup(i)" small icon round>
                    <v-icon small>fas fa-times</v-icon>
                  </v-btn>
                </div>
                <span v-if="group.items.length > 1" class="filter-group-operator">
                  {{ group.operator === 'and' ? 'Y' : 'O' }}
                </span>
              </div>
              <div
                v-for="(item, b) in group.items"
                :key="`item-${i}-${b}`"
                class="filter-condition-row">
                <div class="filter-condition-name">
                  <h4>{{ getfilterAndAmountTitle(item.field) }}</h4>
                  <v-tooltip v-if="getFilterTooltip(item.field)" left max-width="320">
                    <v-btn slot="activator" icon small flat style="min-width:24px;height:24px;margin:0;padding:0;">
                      <v-icon small color="blue-grey lighten-2">fas fa-question-circle</v-icon>
                    </v-btn>
                    <div style="line-height:1.5" v-html="getFilterTooltip(item.field)"></div>
                  </v-tooltip>
                </div>
                <div v-if="item.operator && item.operator !== 'in'" class="filter-condition-operator">
                  {{ getOperatorName(item.operator) }}
                </div>
                <div class="filter-condition-value">
                  {{ parseFilterValue(item.field, item.value) }}
                </div>
              </div>
            </div>
            <div
              v-if="i !== filters.items.length - 1"
              :key="`connector-${i}`"
              class="group-connector">
              <span class="group-connector-label">
                {{ logicalOperator === 'and' ? 'Y' : 'O' }}
              </span>
            </div>
          </template>
        </div>
      </scrollbar>
    </template>
    <v-layout v-else row wrap mt-3 justify-space-between align-center>
      <v-flex xs12 class="text-xs-center">
        <v-icon small class="mr-1 mb-1">
          fas fa-info-circle
        </v-icon>
        <h3 class="d-inline-block">
          No hay filtros que mostrar
        </h3>
      </v-flex>
    </v-layout>
    <groups-dialog
      :show="filtersDialog"
      :group="groupToEdit"
      @new-group="newGroup"
      @group-edited="groupEdited"
      @close="closeFiltersDialog"/>
  </div>
</template>

<script>
import Scrollbar from 'vue-perfect-scrollbar';
import DialogV2 from '@/components/global/DialogV2';
import GroupsDialog from '@/components/global/CustomerFilters/GroupsDialog';
import filtersMixin from '@/mixins/workflowFilters';
import comparisonOperatorsMixin from '@/mixins/comparisonOperators';

export default {
  inject: ['$validator'],
  props: {
    defaultFilters: {
      type: Object,
      default: () => ({}),
    },
    showBtn: {
      type: Boolean,
      default: true,
    },
  },
  components: {
    DialogV2,
    GroupsDialog,
    Scrollbar,
  },
  mixins: [
    filtersMixin,
    comparisonOperatorsMixin,
  ],
  data() {
    let emptyFilters = {};
    if (Object.keys(this.defaultFilters).length) {
      emptyFilters = {
        ...this.defaultFilters,
      };
    } else {
      emptyFilters = {
        type: 'group',
        operator: 'and',
        items: [],
      };
    }
    return {
      indexGroupToEdit: null,
      filtersDialog: false,
      emptyFilters,
      filters: {
        ...emptyFilters,
      },
    };
  },
  computed: {
    groupToEdit() {
      let group = {};
      if (this.indexGroupToEdit !== null) {
        group = this.filters.items[this.indexGroupToEdit];
      }
      return group;
    },
    logicalOperator() {
      return this.filters.operator;
    },
  },
  methods: {
    closeFiltersDialog() {
      if (this.indexGroupToEdit !== null) {
        this.indexGroupToEdit = null;
      }
      this.filtersDialog = false;
    },
    newGroup(group) {
      this.filters.items.push({
        type: 'group',
        ...group,
      });
    },
    groupEdited(group) {
      this.filters.items[this.indexGroupToEdit] = {
        type: 'group',
        ...group,
      };
    },
    editGroup(i) {
      this.indexGroupToEdit = i;
      setTimeout(() => {
        this.filtersDialog = true;
      }, 200);
    },
    deleteGroup(i) {
      const tmp = [];
      for (let b = 0; b < this.filters.items.length; b += 1) {
        if (b !== i) {
          tmp.push(this.filters.items[b]);
        }
      }
      this.filters.items = tmp;
    },
  },
  watch: {
    filters: {
      handler() {
        this.$emit('input', this.filters);
      },
      deep: true,
    },
  },
};
</script>

<style scoped>
.filter-groups-wrap {
  padding: 2px 4px 4px;
}
.filter-group-card {
  border: 1px solid #cfd8dc;
  border-radius: 8px;
  background: #fff;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);
  margin-bottom: 4px;
  overflow: hidden;
}
.filter-group-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 2px 8px;
  background: #f5f5f5;
  border-bottom: 1px solid #e0e0e0;
  min-height: 34px;
}
.filter-group-actions {
  display: flex;
  align-items: center;
  gap: 2px;
}
.filter-group-operator {
  font-size: 11px;
  font-weight: 700;
  color: #607d8b;
  background: #eceff1;
  padding: 2px 10px;
  border-radius: 10px;
  letter-spacing: 0.5px;
}
.filter-condition-row {
  display: flex;
  align-items: center;
  padding: 6px 12px;
  border-bottom: 1px solid #f0f0f0;
}
.filter-condition-row:last-child {
  border-bottom: none;
}
.filter-condition-name {
  display: flex;
  align-items: center;
  flex: 0 0 150px;
  min-width: 0;
}
.filter-condition-name h4 {
  margin: 0;
  font-size: 13px;
  white-space: normal;
  word-break: break-word;
}
.filter-condition-operator {
  flex: 0 0 auto;
  font-size: 12px;
  color: #78909c;
  padding: 0 8px;
  white-space: nowrap;
}
.filter-condition-value {
  flex: 1;
  padding-left: 12px;
  border-left: 1px solid #e0e0e0;
  font-size: 13px;
  color: #37474f;
  min-width: 0;
  word-break: break-word;
}
.group-connector {
  text-align: center;
  padding: 4px 0;
  margin-bottom: 4px;
}
.group-connector-label {
  font-size: 11px;
  font-weight: 700;
  color: #fff;
  background: #90a4ae;
  padding: 2px 12px;
  border-radius: 10px;
  letter-spacing: 0.5px;
}
</style>



// WEBPACK FOOTER //
// src/components/global/CustomerFilters/Index.vue